<template>
  <router-view></router-view>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: "app",
  created() {
    this.getUserAgentInfo();
  },
  beforeDestroy() {
    if (this.$viewportTracker) {
      this.$viewportTracker.stop();
    }
  },
  watch: {
    countryId() {
      this.initializeLanguage();
    }
  },
  computed: {
    ...mapState('userOtherSetting', ['countryId']),
    ...mapGetters('userOtherSetting', ['targetLanguage'])
  },
  methods: {
    ...mapActions('uaParser', ['getUserAgentInfo']),

    async initializeLanguage() {
      this.$i18n.locale = this.targetLanguage;
    }
  },
  mounted() {
    // Start tracking the visible viewport height (single source of truth for
    // lesson-room heights + the --app-vh CSS variable). Runs before the RUM
    // init below so it is unaffected by the early returns there.
    this.$viewportTracker.start();

    // const applicationId = getApplicationId(getServiceId(), this.countryId);
    const rumApplicationId = process.env.VUE_APP_AWS_RUM_APPLICATION_ID;
    const rumIdentityPoolId = process.env.VUE_APP_AWS_RUM_IDENTITY_POOL_ID;

    if (!rumApplicationId || !rumIdentityPoolId) {
      console.warn('AWS RUM Application ID or Identity Pool ID is not set. AWS RUM will not be initialized.');
      return;
    }
    // debugging only while development is ongoing, will remove this log statement once we confirm the correct Application ID is being used
    console.log('RUM Application ID:', rumApplicationId, ' RUM Identity Pool ID:', rumIdentityPoolId);

    if (rumApplicationId && rumIdentityPoolId) {
      // only include CWR initialization script if we have RUM APPLICATION ID and IDENTITY POOL ID
      (function(n,i,v,r,s,c,x,z){x=window.AwsRumClient={q:[],n:n,i:i,v:v,r:r,c:c};window[n]=function(c,p){x.q.push({c:c,p:p});};z=document.createElement('script');z.async=true;z.src=s;document.head.insertBefore(z,document.head.getElementsByTagName('script')[0]);})(
        'cwr',
        rumApplicationId,
        '1.0.0',
        'ap-northeast-1',
        'https://client.rum.us-east-1.amazonaws.com/1.19.0/cwr.js',
        {
          sessionSampleRate: 0.04 ,
          identityPoolId: rumIdentityPoolId,
          endpoint: "https://dataplane.rum.ap-northeast-1.amazonaws.com" ,
          telemetries: ["http","errors","performance"] ,
          allowCookies: true ,
          enableXRay: true ,
          signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
        }
      );
    }
  }
};
</script>
